import axios from "axios";

export default async function verifySpecificFuncPermissions(id = null) {
    let route = '/api/configurations/specific-functionalities/verify'
    if (!!id) route += `?id=${id}`

    try {
        return (await window.axios.get(route)).data.data;
    } catch (error) {
        if ([401, 403].includes(error?.response?.status)) {
            return id ? false : {};
        }

        throw error;
    }
}
